PJQ.constants.subscriptions = {
	types: {
		FREE: 1,
		BASIC: 2,
		PRO: 3,
		ENTERPRISE: 4
	},
	colors: {
		1: "#7e7e7e",
		2: "#EF6C00",
		3: "#3073bb",
		4: "#5E35B1"
	},
	names: {
		1: "FREE",
		2: "BASIC",
		3: "PRO",
		4: "ENTERPRISE"
	},
	names: {
		1: "FREE",
		2: "BASIC",
		3: "PRO",
		4: "ENTERPRISE"
	},
	costs: {
		1: 0,
		2: 999,
		3: 1999,
		4: 4999
	}
};

PJQ.models.subscriptions = {};

PJQ.models.subscriptions.Subscription = PJQ.models.BaseModel.extend({
	idAttribute: 'subscriptionId',
	parse: function (model) {
		if (model != null) {
			if (model.newSubscription != null) {
				this.newSubscription = new PJQ.models.subscriptions.Subscription(model.newSubscription);
			}
			else {
				this.newSubscription = null;
			}
		}
		return model;
	},
	hasFeature: function (feature) {
		if (PJQ.app.session.get('onAccount') || (PJQ.app.session.get('portalId') !== PJQ.constants.panteraPortalId)) {
			return true;
		}

		switch (feature.toLowerCase()) {
			case 'projects':
				return this.get('hasProjects');
			case 'contacts':
				return this.get('hasContacts');
			case 'documents':
				return this.get('hasDocuments');
			case 'calendar':
				return this.get('hasCalendar');
			case 'reports':
				return this.get('hasReports');
			case 'projectmessaging':
				return this.get('hasProjectMessaging');
			case 'privatemessaging':
				return this.get('hasPrivateMessaging');
			case 'bidforms':
				return this.get('hasBidForms');
			case 'drawings':
				return this.get('hasDrawings');
			case 'projectattachments':
				return this.get('hasProjectAttachments');
			case 'rfi':
				return this.get('hasRFI');
			case 'submittals':
				return this.get('hasSubmittals');
			case 'dailyreports':
				return this.get('hasDailyReports');
			case 'schedule':
				return this.get('hasSchedule');
			case 'punchlist':
				return this.get('hasPunchList');
			case 'actionitems':
				return this.get('hasActionItems');
			case 'projectreports':
				return this.get('hasProjectReports');
			case 'bidfiler':
				return this.get('hasBidFiler');
			default:
				return true;
		}
	},
	getCostsPerUser: function (callback) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'subscription'
				},
				{
					endpoint: 'cost'
				}
			])
		}).get().done(_.bind(function (data) {
			if (typeof callback === 'function') {
				callback(data);
			}
		}, this)).fail(_.bind(function () {
			if (typeof callback === 'function') {
				callback(data);
			}
		}, this));
	}
});

PJQ.views.subscriptions = {};

PJQ.views.subscriptions.EditSubscriptionModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-edit-subscription'),
		maxWidth: 1200,
		isVerticalCenter: true,
		isShowCloseButton: true,
		preventTrial: false,
		onSave: null
	},
	events: {
		'click .sub-option': 'subscriptionSelected',
		'click .btn-submit': 'submit',
		'click .btn-submit-trial': 'submitTrial'
	},
	beforeModalCreated: function () {
		if (PJQ.app.session.subscription.id !== PJQ.constants.subscriptions.types.FREE) {
			this.selectedSubscriptionId = PJQ.app.session.subscription.id;
		}
		else {
			this.selectedSubscriptionId = PJQ.constants.subscriptions.types.FREE;
		}

		this.options.forTrialOffer = !this.options.preventTrial && (PJQ.app.session.subscription.get('trialExpiresOn') == null || (PJQ.helpers.dateHelpers.getDateDiff(new Date(PJQ.app.session.subscription.get('trialExpiresOn')), new Date(), 'days') + 1) > 0);
	},
	renderData: function () {
		return {
			forTrialOffer: this.options.forTrialOffer,
			activeSubscription: PJQ.app.session.subscription,
			selectedSubscriptionId: this.selectedSubscriptionId
		}
	},
	subscriptionSelected: function (e) {
		this.selectedSubscriptionId = parseInt($(e.currentTarget).data('subId'));
		this.render();
	},
	submitTrial: function () {
		let $err = this.$('.error-outer');
		if (this.selectedSubscriptionId === PJQ.constants.subscriptions.types.FREE) {
			$err.html('Please select a plan');
			return;
		}
		else {
			$err.empty();
		}

		PJQ.app.session.updateTrial(this.selectedSubscriptionId, _.bind(function (data) {
			if (data == null || data.subscription == null) {
				PJQ.notifications.notify.errorNotify({
					message: 'Encountered an error starting your free trial.  Please contact customer service.'
				});
			}
			else {
				PJQ.notifications.notify.successNotify({
					message: 'Free trial started'
				});
				this.removeModal();
			}
		}, this), _.bind(function () {
			PJQ.notifications.notify.errorNotify({
				message: 'Encountered an error starting your free trial.  Please contact customer service.'
			});
			this.removeModal();
		}, this));
	},
	submit: function () {
		let $err = this.$('.error-outer'),
			newSubscription = PJQ.app.session.subscription.get('newSubscription');
		if (this.selectedSubscriptionId === PJQ.constants.subscriptions.types.FREE) {
			$err.html('Please select a plan');
			return;
		}
		else if (this.selectedSubscriptionId === PJQ.app.session.subscription.id && newSubscription == null) {
			$err.html('This plan is already active on your account');
			return;
		}
		else {
			$err.empty();
		}

		if (PJQ.app.session.subscription.get('isFreeTrial') || this.selectedSubscriptionId > PJQ.app.session.subscription.id) {
			// this is an upgrade that will trigger a payment, show the payment modal
			this.removeModal();
			new PJQ.views.payment.SubscriptionPaymentModal({
				selectedSubscriptionId: this.selectedSubscriptionId
			});
		}
		else {
			// this is a change that wont trigger a payment, upgrade the subscription
			let loader = new PJQ.Loader(this.$('.modal-content')),
				err = function () {
					loader.remove();
					PJQ.notifications.notify.errorNotify({
						message: 'Encountered an error upgrading your subscription.  Please contact customer service.'
					});
				};
			PJQ.app.session.changeSubscription(this.selectedSubscriptionId, _.bind(function (data) {
				if (data == null || data.subscription == null) {
					err();
				}
				else {
					PJQ.notifications.notify.successNotify({
						message: 'Subscription successfully updated'
					});
					this.removeModal();

					if(typeof this.options.onSave === 'function'){
						this.options.onSave();
					}
				}
			}, this), _.bind(function () {
				err();
			}, this));
		}
	},
});

PJQ.views.subscriptions.DisableAutoRenewModal = PJQ.views.BaseModal.extend({
	beforeModalCreated: function () {
		this.options = _.defaults({
			header: "Disable Auto Renew",
			body: "Are you sure you want to disable auto-renew?<br />Your users will continue to have access to your current subscription's features until it expires on <strong>" + PJQ.helpers.dateHelpers.getDateString(new Date(this.options.subscription.get('expiresOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true) + "</strong>.",
			isShowOkButton: true,
			okButtonColorClass: 'danger',
			okButtonText: "Disable Auto-Renew",
			onOk: _.bind(function () {
				if (typeof this.options.onYes === 'function') {
					this.options.onYes();
				}
			}, this),
			isShowSecondaryButton: true,
			secondaryButtonText: "Keep Auto-Renew Enabled",
			onSecondary: _.bind(function () {
				if (typeof this.options.onNo === 'function') {
					this.options.onNo();
				}
			}, this)
		}, this.options);
	}
});